export class CreateSapJobInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "objectId",
            "baseName": "objectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "mode",
            "baseName": "mode",
            "type": "SapIngestionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateSapJobInput.attributeTypeMap;
    }
    constructor() {
    }
}
